function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 211 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17361"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 3886",
    width: 24,
    height: 24,
    rx: 4,
    style: {
      fill: "#f4f4f4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 18"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50899",
    d: "M14.605 3.854h-3.3a2.321 2.321 0 0 0-4.549 0h-3.3a.464.464 0 0 0 0 .928h.928v7.891a2.321 2.321 0 0 0 2.321 2.321h4.642a2.321 2.321 0 0 0 2.321-2.321v-7.89h.928a.464.464 0 1 0 0-.928zm-5.57-.928a1.393 1.393 0 0 1 1.309.928H7.726a1.393 1.393 0 0 1 1.309-.928zm-.928 8.356a.464.464 0 0 1-.928 0V7.568a.464.464 0 0 1 .928 0zm2.785 0a.464.464 0 0 1-.928 0V7.568a.464.464 0 1 1 .928 0z",
    transform: "translate(2.994 3.928)",
    style: {
      fill: "#afafaf"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete.e27458844a4ac7a261f62b6074ef3ec7.svg";